// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../stores/mobx-compat";

import PageHeader from '../../ui/PageHeader';
import Tabs from '../../ui/Tabs';
import Button from '../../ui/Button';
import Select from '../../ui/Select';
import { PlusIcon } from '../../ui/icons';
import EmailSettings from './EmailSettings';
import Templates from './Templates';
import Unsubscribes from './Unsubscribes';
import AddEmailDomainModal from './EmailSettings/Modals/AddEmailDomain';

class Recover extends Component {
  state = { modalOpen: false, active: 'settings' };

  componentDidMount() {
    // initAppState may have skipped this fetch (missing clientId, etc.) or
    // the data may have been cleared on logout — refetch on mount so the
    // domain selector and the active domain populate correctly on refresh.
    const em = this.props.store.emailManagement;
    if (_.isEmpty(em.emailDomains)) {
      em.getEmailDomains().then(() => em.getTemplates());
    } else if (em.activeEmailDomainName && _.isEmpty(em.templates)) {
      em.getTemplates();
    }
  }

  setDomain = (e) => {
    this.props.store.emailManagement.setActiveEmailDomainName(null, { value: e.target.value });
  };

  render() {
    const { emailDomains, activeEmailDomainName } = this.props.store.emailManagement;
    const count = _.size(emailDomains);
    const tabs = [
      { value: 'settings', label: 'Email Settings' },
      { value: 'templates', label: 'Templates' },
      { value: 'unsubs', label: 'Unsubscribes' },
    ];

    return (
      <>
        <PageHeader
          eyebrow="Recover"
          title={<>Win back <em>abandoned</em> leads.</>}
          sub="Configure your domains, manage templates, and review unsubscribes."
          actions={count > 0 && (
            <div className="flex items-center gap-2">
              <Select
                value={activeEmailDomainName || ''}
                onChange={this.setDomain}
                style={{ minWidth: 220 }}
              >
                {Object.keys(emailDomains).map((d) => <option key={d} value={d}>{d}</option>)}
              </Select>
              {count < 3 && (
                <Button
                  variant="primary"
                  icon={PlusIcon}
                  onClick={() => this.setState({ modalOpen: true })}
                >
                  Add domain
                </Button>
              )}
            </div>
          )}
        />
        <Tabs
          value={this.state.active}
          onChange={(v) => this.setState({ active: v })}
          items={tabs}
        />

        {this.state.active === 'settings' && (
          <EmailSettings handleModalOpen={() => this.setState({ modalOpen: true })} />
        )}
        {this.state.active === 'templates' && <Templates />}
        {this.state.active === 'unsubs' && <Unsubscribes />}

        <AddEmailDomainModal
          open={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
        />
      </>
    );
  }
}

export default inject('store')(observer(Recover));
